import React, { useContext } from 'react';
import { Row, Col, Text } from '@firsttable/web-components/atoms';
import RowHead from '@firsttable/web-components/molecules/RowHead';
import { ContainerContent } from '@firsttable/web-components/molecules';
import BodyTitle from '@firsttable/web-components/atoms/BodyTitle';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { TrackProvider } from '@components/analytics/context/AnalyticsContext';
import PostCard from '../molecules/PostCard';
import SEO from '../SEO';
import SilverstripeContext from '../context/Silverstripe';

const Blog = () => {
  const { page } = useContext(SilverstripeContext);
  const { competitions } = page;

  const currentCompetitions = competitions.filter(
    (competition) => !competition.hasEnded && competition.isOpen
  );
  const pastCompetitions = competitions.filter(
    (competition) => competition.hasEnded || !competition.isOpen
  );

  return (
    <TrackProvider pageEventName="marketing_page_viewed" source_page="competitions home">
      <SEO
        id={page.id}
        title={page.metaTitleFormatted}
        description={page.metaDescription}
        ogImage={page.ogImage}
        metaTags={page.metaTags}
        slug={page.slug}
      />
      <ContainerContent>
        <RowHead title={page.title} />

        <BodyTitle size="l">Current Competitions</BodyTitle>
        {currentCompetitions.length ? (
          <Row gap={40}>
            {currentCompetitions.map((competition) => (
              <Column key={competition.id} competition={competition} />
            ))}
          </Row>
        ) : (
          <Text>No current competitions. Check back soon!</Text>
        )}

        {pastCompetitions.length > 0 && (
          <>
            <BodyTitle size="l" mt={[20, 50]}>
              Past Competitions
            </BodyTitle>
            <Row gap={40}>
              {pastCompetitions.map((competition) => (
                <Column key={competition.id} competition={competition} />
              ))}
            </Row>
          </>
        )}
      </ContainerContent>
    </TrackProvider>
  );
};

export default Blog;

const Column = ({ competition }) => (
  <Col width={[1, 1 / 2, 1 / 3]} mb={['20px', '40px']} pl={40}>
    <PostCard
      title={competition.title}
      description={competition.summary}
      imageUrl={competition.featuredImage?.url || competition.photos.edges[0]?.node.url}
      author={competition.defaultCity?.menuTitle}
      date={
        competition.isOpen
          ? `Enter by ${dayjs(competition.end, 'YYYY-MM-DD HH:mm:ss').format('D MMMM YYYY')}`
          : ''
      }
      linkTo={competition.slug}
    />
  </Col>
);

Column.propTypes = {
  competition: PropTypes.object.isRequired,
};
